import script from "./Accueil.vue?vue&type=script&setup=true&lang=js"
export * from "./Accueil.vue?vue&type=script&setup=true&lang=js"

import "./Accueil.vue?vue&type=style&index=0&id=727ddfbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-727ddfbe"]])

export default __exports__